export const admin = {
  // Gate states
  loading: 'Loading...',
  deniedTitle: 'You do not have access permission',
  deniedBody: 'This account is not registered as an administrator.',
  logout: 'Log Out',

  // Login
  login: {
    label: 'Admin',
    title: 'Administrator Login',
    email: 'Email Address',
    emailPlaceholder: 'admin@example.com',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    submit: 'Log In',
    submitting: 'Logging in...',
    invalidCredentials: 'The email address or password is incorrect',
  },

  // Dashboard header
  brandLabel: 'EachTeach Admin',
  title: 'Service Management',
  backToHome: 'To Home',

  // Stats / actions
  publishedServices: 'Published Services',
  unit: '',
  addNew: 'Add New',

  // Toasts
  toast: {
    updated: 'Service updated',
    updateFailed: 'Update failed (check permissions or connection)',
    added: 'Service added',
    addFailed: 'Add failed (check permissions or connection)',
    deleted: 'Service deleted',
    deleteFailed: 'Delete failed (check permissions or connection)',
  },

  // Service list
  list: {
    empty: 'No services yet. Create one from "+ Add New".',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Delete "{{name}}"?',
    cancel: 'Cancel',
    confirmDeleteButton: 'Delete',
  },

  // Service form modal
  modal: {
    editTitle: 'Edit Service',
    addTitle: 'Add New Service',
    serviceName: 'Service Name',
    serviceNamePlaceholder: 'e.g. EachTeach Community',
    shortDescription: 'Short Description',
    shortDescriptionPlaceholder: 'One-line description shown on the card',
    detail: 'Detailed Description',
    detailPlaceholder:
      'Detailed description shown when expanding "View Details" (within 500 characters)',
    linkUrl: 'Link URL (optional)',
    image: 'Image',
    changeImage: 'Change Image',
    clickToSelect: 'Click to select an image',
    dragDrop: 'Or drag & drop here (JPG, PNG, WebP)',
    imageUploading: 'Uploading image...',
    imageTypeError: 'Please select a JPG, PNG, or WebP image',
    imageSizeError: 'Image size must be 5MB or less',
    imageUploadError: 'Image upload failed (check permissions or connection)',
    cancel: 'Cancel',
    update: 'Update',
    add: 'Add',
    requiredMark: '*',
  },
};
